// extracted by mini-css-extract-plugin
export default {"menuList":"EntitySelectMenuList-module__menuList--C6m9d"};